import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const questionsOptions = {
  baseUrl: `${BACK_END_URL}/question`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class QuestionsClient extends CandyClient {
  constructor() {
    super(questionsOptions);
  }

  // Get all questions by quiz ID
  async getQuestionsByQuizId(quizId) {
    return this.get(`/list/${quizId}`);
  }

  // Get a question by ID
  async getQuestionById(questionId) {
    return this.get(`/id/${questionId}`);
  }
  
  // Create a new question
  async createQuestion(questionData) {
    return this.post(`/create`, questionData, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  // Update a question by ID
  async updateQuestion(questionId, questionData) {
    return this.put(`/update/${questionId}`, questionData, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  // Delete a question by ID
  async deleteQuestion(questionId) {
    return this.delete(`/delete/${questionId}`, null, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
  }
}
